import PropTypes from 'prop-types';

import DataWrapper from '../../DataWrapper';
import AttributeListing from './components/AttributeListing';
import ZonesLegend from './components/ZonesLegend';
import ZonesCharts from './components/ZonesCharts';

import './style.scss';

const Zones = ({feature}) => {
	return (
		<>
			<DataWrapper noDataInfo="Select zone in the map to display statistics here">
				{feature ? (
					<>
						<ZonesCharts feature={feature} />
						<AttributeListing featureProperties={feature?.properties} />
					</>
				) : null}
			</DataWrapper>
			<ZonesLegend />
		</>
	);
};

Zones.propTypes = {
	feature: PropTypes.object,
};

export default Zones;
